import React, { useState, useEffect } from 'react';
import { Button, Table, Input, Breadcrumb } from 'antd';
import { HomeOutlined } from '@ant-design/icons';

import AjouterClientVente from './modals/AjouterClientVente';
import { fetchClientVentes } from '../../../../services/ventes/clientVentesApi';

const ClientVentes = () => {
    const [clientVentes, setClientVentes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isOpenAddModal, setIsOpenAddModal] = useState(false);
    const [search, setSearch] = useState('');

    useEffect(() => {
        loadClientVentes();
    }, []);

    const loadClientVentes = () => {
        setLoading(true);
        fetchClientVentes()
            .then((response) => {
                setClientVentes(response.data.ventes);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                // Handle error
            });
    };

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h4 className='col-lg-11'>
                    <div className="mb-2">
                        <i className="bx bx-tag me-2" style={{ color: "var(--primary-color3) !important" }} />
                        <h3 style={{ color: "var(--primary-color3) !important" }}>Client Ventes</h3>
                    </div>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <HomeOutlined />
                        </Breadcrumb.Item>
                        <Breadcrumb.Item style={{ color: "var(--primary-color3) !important" }}>Client Ventes</Breadcrumb.Item>
                    </Breadcrumb>
                </h4>
                <Button onClick={() => setIsOpenAddModal(true)} style={{ backgroundColor: 'var(--primary-color5)', color: "white" }}>
                    <span>Ajouter Client Vente</span>
                </Button>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '10px 0' }}>
                <Input
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Rechercher"
                    value={search}
                    suffix={<i className="bi bi-search" />}
                    style={{ width: '200px' }}
                />
            </div>
            <Table dataSource={clientVentes} loading={loading} /* Add columns and other props */ />
            <AjouterClientVente isOpen={isOpenAddModal} onClose={() => setIsOpenAddModal(false)} onSubmit={loadClientVentes} />
        </>
    );
};

export default ClientVentes;
